module.exports = __webpack_public_path__ + "media/sales_marketing_strategies/graph_1_1-e37acc70.svg";